import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationStorageService {

  private KEY = 'translated_columns';

  saveColumns(columns: any[]) {
    localStorage.setItem(this.KEY, JSON.stringify(columns));
  }

  getColumns(): any[] {
    const data = localStorage.getItem(this.KEY);
    return data ? JSON.parse(data) : [];
  }

  clear() {
    localStorage.removeItem(this.KEY);
  }
}
